<template>
  <div class="title">
    <p :style="'color:' + titleObj.color + ';border-bottom: 2px solid ' + titleObj.color">
      {{titleObj.text}}
      <span v-show="titleObj.link" @click="goRanking(titleObj)">
        <!-- <router-link :to="titleObj.link"> -->
          更多 <i class="el-icon-arrow-right"></i>
        <!-- </router-link> -->
      </span>
    </p>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    titleObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {}
  },
  methods: {
    goRanking (obj) {
      console.log(obj)
      if (obj.type) {
        this.$router.push({
          name: obj.link,
          params: {
            type: obj.type
          }
        })
      } else {
        this.$router.push({
          path: obj.link
        })
      }
      // this.$router.push({
      //   name: path,
      //   params: {
      //     type: '0'
      //   }
      // })
    }
  }
}
</script>
<style lang="less" scoped>
  .title{
    background-color: white;
    p{
      font-size: 20px;
      padding: 0 0 10px 0;
      margin: 0;
      span{
        float: right;
        font-size: 14px;
        margin-top: 5px;
        cursor: pointer;
        a{
          text-decoration: none;
          color: #9E8466;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/recommendTitle.vue


// WEBPACK FOOTER //
// src/components/Home/recommendTitle.vue